document.addEventListener("DOMContentLoaded", function () {
  const toggleTitles = document.querySelectorAll(".app_toggle_tit");

  toggleTitles.forEach(titleEl => {
    titleEl.addEventListener("click", function () {              
      const content = this.nextElementSibling; 

      this.classList.toggle("active");
      content.classList.toggle("active");  
    });
  });

  const deviceWrap = document.querySelector(".device_fixed_wrap");
  const headerWrap =
    document.querySelector(".header-wrapper--border-bottom") ||
    document.querySelector(".header-wrapper");
  const triggerButtons =
    document.querySelector(".product__info-wrapper .product-form__buttons") ||
    document.querySelector(".product-form__buttons");

  function getTriggerPoint() {
    if (!triggerButtons) return 0;
    const rect = triggerButtons.getBoundingClientRect();
    return rect.bottom + (window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function updateDeviceWrapState() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const triggerPoint = getTriggerPoint();

    if (deviceWrap) {
      if (scrollY > triggerPoint) {
        deviceWrap.classList.add("active");
      } else {
        deviceWrap.classList.remove("active");
      }
    }

    if (headerWrap) {
      if (scrollY > 0) {
        headerWrap.classList.add("active");
      } else {
        headerWrap.classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", updateDeviceWrapState, { passive: true });
  window.addEventListener("resize", updateDeviceWrapState);
  window.addEventListener("load", updateDeviceWrapState);
  updateDeviceWrapState();

  
  
});

$(function() {
  var topDesc = $('.sub-desc-wrap .toggle_box');
     topDesc.addClass('collapsed');
     topDesc.find('.hide').hide();
     topDesc.eq(0).removeClass('collapsed');
     topDesc.eq(0).find('.hide').show();

     $('.sub-desc-wrap .toggle_box > .title').click(function(){
         var firstDesc = $(this).parents('.sub-desc-wrap .toggle_box:first');
         if(firstDesc.hasClass('collapsed')){
             topDesc.addClass('collapsed').removeClass('show');
             topDesc.find('.hide').slideUp(100);
             firstDesc.removeClass('collapsed').addClass('show');
             firstDesc.find('.hide').slideDown(100);
         } else {
             firstDesc.removeClass('show').addClass('collapsed');
             firstDesc.find('.hide').slideUp(100);
         }
         return false;
     });



    var bottomDesc = $('.dis_wrap .toggle_box');
    var bottomDesc2 = $('.dis_wrap .toggle_box2');
    bottomDesc.addClass('collapsed');
    bottomDesc.find('.hide').hide();
    bottomDesc.eq(0).removeClass('collapsed').addClass('show');
    bottomDesc.eq(0).find('.hide').show();

     bottomDesc2.find('.hide').hide();
     bottomDesc2.addClass('collapsed');
     bottomDesc2.eq(0).removeClass('collapsed');
     bottomDesc2.eq(0).find('.hide:first').show();
    
    $('.dis_wrap .toggle_box .title').click(function(){
      var firstDesc = $(this).parents('.dis_wrap .toggle_box:first');
      if(firstDesc.hasClass('collapsed')){
        bottomDesc.addClass('collapsed').removeClass('show');
        bottomDesc.find('.hide').slideUp(100);
        firstDesc.removeClass('collapsed').addClass('show');
        firstDesc.find('.hide').slideDown(100);
      } else {
        firstDesc.removeClass('show').addClass('collapsed');
        firstDesc.find('.hide').slideUp(100);
      }
      return false;
    });


    if($(window).width() < 768) {
      bottomDesc2.eq(0).find('.hide').hide();
      bottomDesc2.eq(0).addClass('collapsed');
      $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
             if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
        
       });
    } else {
       $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
           if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
       });
    }

      // Frequently Asked Question
     var article = $('.faq>.faqBody>.article');
     article.addClass('t_hide');
     article.find('.a').hide();
     article.eq(0).removeClass('t_hide');
     article.eq(0).find('.a').show();
     $('.faq>.faqBody>.article>.q>a').click(function(){
         var myArticle = $(this).parents('.article:first');
         if(myArticle.hasClass('t_hide')){
             article.addClass('t_hide').removeClass('show');
             article.find('.a').slideUp(100);
             myArticle.removeClass('t_hide').addClass('show');
             myArticle.find('.a').slideDown(100);
         } else {
             myArticle.removeClass('show').addClass('t_hide');
             myArticle.find('.a').slideUp(100);
         }
         return false;
     });

     var shortsSlide = new Swiper('.shorts-slide', {
            slidesPerView: 1.8, 
            spaceBetween: 10, 
            pagination: {
                el: ".short-pagination",
                type: "progressbar",
              },
            breakpoints: { 
             
              768: {
               
              },
              1024: {
                slidesPerView: 1.8,
              },
            }
      });
  
     var bodySlide = new Swiper('.body-slide', {
         slidesPerView: 1.2, 

       spaceBetween: 10, 
         pagination: {
             el: ".body-pagination",
             type: "progressbar",
           },
       observer: true,
      observeParents: true,
         breakpoints: { 
         
          
           1024: {
             slidesPerView: 2.3,
             spaceBetween: 20, 
           },
         }
   });

   var vitaSlide = new Swiper('.vita-slide', {
         slidesPerView: 1.2, 
         spaceBetween: 10, 
         autoHeight: true,
     
         breakpoints: { 
         
          1024: {
             slidesPerView: 1.5,
             spaceBetween: 20, 
           },
           
         }
   });

    var vitaSlide = new Swiper('.vita-slide2', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

      var vitaSlide = new Swiper('.vita-slide3', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

  var detailLogo1 = new Swiper('.detail_logo1', {
    slidesPerView: 2, 
    loop:true,
    speed:3000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

  var detailLogo2 = new Swiper('.detail_logo2', {
    slidesPerView: 'auto', 
     centeredSlides: true,
   loop:true,
    autoplay:{
        delay : 2500,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
    pagination: {
        el: ".logo-page",
        clickable: true,
      },
      navigation: {
        nextEl: ".logo-next",
        prevEl: ".logo-prev",
      },
    
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

var deviceSlide = new Swiper('.device_slide', {
            slidesPerView: 'auto', 
            spaceBetween: 20, 
            slidesOffsetAfter:50,
               pagination: {
              el: ".device-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 25, 
                 slidesOffsetAfter:0,
              },
              
            }
      });

var allinoneSwiper = null;
function toggleAllinoneSwiper() {
  var selector = '.AllinOne .allinoneSwiper';
  if (!document.querySelector(selector)) return;

  if (window.innerWidth <= 768) {
    if (!allinoneSwiper) {
        allinoneSwiper = new Swiper(selector, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: false,
          observer: true,
          observeParents: true,
          allowTouchMove: true,
        navigation: {
          nextEl: ".AllinOne .allinone_next",
          prevEl: ".AllinOne .allinone_prev",
        },
        pagination: {
          el: ".AllinOne .allinone-page",
          clickable: true,
        }
      });
    } else {
      allinoneSwiper.update();
    }
  } else if (allinoneSwiper) {
    allinoneSwiper.destroy(true, true);
    allinoneSwiper = null;
  }
}

toggleAllinoneSwiper();
window.addEventListener("resize", toggleAllinoneSwiper);

var modeSwiper = new Swiper('.modeSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            allowTouchMove: true,
            observer: true,
            observeParents: true,
            navigation: {
              nextEl: '.threeModes .modes_next',
              prevEl: '.threeModes .modes_prev'
            },
            // legacy swiper fallback keys
            nextButton: '.threeModes .modes_next',
            prevButton: '.threeModes .modes_prev',
            pagination: {
              el: '.threeModes .modes_tabs',
              clickable: true,
              bulletClass: 'modes_tab',
              bulletActiveClass: 'is-active',
              renderBullet: function (index, className) {
                var labels = ['Three Modes', 'Red Led', 'Blue Led', 'Purple Led'];
                return '<button type="button" class="' + className + '">' + labels[index] + '</button>';
              }
            }
      });

var modesTabsWrap = document.querySelector('.threeModes .modes_tabs_wrap');
var modesTabsTrack = modesTabsWrap ? modesTabsWrap.querySelector('.modes_tabs') : null;
var modesTabsPrevPaddle = null;
var modesTabsNextPaddle = null;

function createModesTabsPaddles() {
  if (!modesTabsWrap || modesTabsPrevPaddle || modesTabsNextPaddle) return;

  modesTabsPrevPaddle = document.createElement('button');
  modesTabsPrevPaddle.type = 'button';
  modesTabsPrevPaddle.className = 'modes_tabs_paddle modes_tabs_paddle_prev';
  modesTabsPrevPaddle.setAttribute('aria-label', 'Previous mode tab');
  modesTabsPrevPaddle.innerHTML = '<span aria-hidden="true">&#8249;</span>';

  modesTabsNextPaddle = document.createElement('button');
  modesTabsNextPaddle.type = 'button';
  modesTabsNextPaddle.className = 'modes_tabs_paddle modes_tabs_paddle_next';
  modesTabsNextPaddle.setAttribute('aria-label', 'Next mode tab');
  modesTabsNextPaddle.innerHTML = '<span aria-hidden="true">&#8250;</span>';

  modesTabsPrevPaddle.addEventListener('click', function() {
    modeSwiper.slidePrev();
  });
  modesTabsNextPaddle.addEventListener('click', function() {
    modeSwiper.slideNext();
  });

  modesTabsWrap.appendChild(modesTabsPrevPaddle);
  modesTabsWrap.appendChild(modesTabsNextPaddle);
}

function getModeRealIndex(swiper) {
  if (!swiper) return 0;
  if (typeof swiper.realIndex === 'number') return swiper.realIndex;
  if (typeof swiper.activeIndex === 'number') return swiper.activeIndex;
  return 0;
}

function updateModesTabsMobileState() {
  if (!modesTabsWrap || !modesTabsTrack) return;

  var modeTabs = modesTabsTrack.querySelectorAll('.modes_tab');
  if (!modeTabs.length) return;

  modesTabsWrap.style.setProperty('--modes-tab-count', modeTabs.length);

  if (window.innerWidth > 768) {
    modesTabsWrap.classList.remove('is-mobile-tabs', 'is-at-start', 'is-at-end');
    modesTabsWrap.style.setProperty('--modes-tabs-start', 0);
    return;
  }

  createModesTabsPaddles();
  modesTabsWrap.classList.add('is-mobile-tabs');

  var visibleCount = 3;
  var activeIndex = getModeRealIndex(modeSwiper);
  var maxStartIndex = Math.max(0, modeTabs.length - visibleCount);
  var startIndex = Math.max(0, Math.min(maxStartIndex, activeIndex - (visibleCount - 2)));
  var isAtStart = startIndex === 0;
  var isAtEnd = startIndex >= maxStartIndex;

  modesTabsWrap.style.setProperty('--modes-tabs-start', startIndex);
  modesTabsWrap.classList.toggle('is-at-start', isAtStart);
  modesTabsWrap.classList.toggle('is-at-end', isAtEnd);

  if (modesTabsPrevPaddle) {
    modesTabsPrevPaddle.disabled = isAtStart;
  }
  if (modesTabsNextPaddle) {
    modesTabsNextPaddle.disabled = isAtEnd;
  }
}

updateModesTabsMobileState();
modeSwiper.on('slideChange', updateModesTabsMobileState);
window.addEventListener('resize', updateModesTabsMobileState);

var motionSlide = new Swiper('.motion_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,  
            loop:true,    
             pagination: {
              el: ".motion-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".motion-next",
              prevEl: ".motion-prev",
            },
    
      });      
var bnaSlide = new Swiper('.bna_slide', {
              slidesPerView: 1.2, 
            spaceBetween: 20, 
            slidesOffsetAfter:30,
             
              pagination: {
              el: ".bna-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 15,
                slidesOffsetAfter:0,
              },
              
            }
    
      });

var comSlide = new Swiper('.comment_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,     
            loop:true,  
             pagination: {
              el: ".com-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".com-next",
              prevEl: ".com-prev",
            },
    
      });

var howToUse = null;
var howToUseMobile = null;
function toggleHowToUseSwiper() {
  var desktopSelector = '.howtoSwiper';
  var mobileSelector = '.howtoMobileSwiper';
  var hasDesktop = !!document.querySelector(desktopSelector);
  var hasMobile = !!document.querySelector(mobileSelector);
  if (!hasDesktop && !hasMobile) return;

  if (window.innerWidth > 768) {
    if (howToUseMobile) {
      howToUseMobile.destroy(true, true);
      howToUseMobile = null;
    }
    if (!howToUse) {
      howToUse = new Swiper(desktopSelector, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.howToUse .howto_next',
          prevEl: '.howToUse .howto_prev'
        },
        // legacy swiper fallback keys
        nextButton: '.howToUse .howto_next',
        prevButton: '.howToUse .howto_prev',
        pagination: {
          el: '.howToUse .howto_tabs',
          clickable: true,
          bulletClass: 'howto_tab',
          bulletActiveClass: 'is-active',
          renderBullet: function (index, className) {
            var labels = ['How to use', 'How to charge'];
            return '<button type="button" class="' + className + '">' + labels[index] + '</button>';
          }
        }
      });
    } else {
      howToUse.update();
    }
  } else if (howToUse) {
    howToUse.destroy(true, true);
    howToUse = null;
  }

  if (window.innerWidth <= 768 && hasMobile) {
    if (!howToUseMobile) {
      howToUseMobile = new Swiper(mobileSelector, {
        slidesPerView: 1.3,
        spaceBetween: 24,
  
        observer: true,
        observeParents: true,
   
      });
    } else {
      howToUseMobile.update();
    }
  }
}

toggleHowToUseSwiper();
window.addEventListener("resize", toggleHowToUseSwiper);

  (function setupFullVideoDeviceScene() {
    var deviceSection = document.querySelector(".device_container");
    var deviceInner = deviceSection ? deviceSection.querySelector(".device_inner") : null;
    var deviceFlex = deviceInner ? deviceInner.querySelector(".device_inner_flex") : null;

    if (!deviceSection) return;

    var mobileMQ = window.matchMedia("(max-width: 768px)");
    var ticking = false;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateScene() {
      var isMobile = mobileMQ.matches;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var trackEl = deviceFlex || deviceSection;
      var trackRect = trackEl.getBoundingClientRect();
      var trackTopDoc = trackRect.top + scrollY;
      var trackHeight = trackEl.offsetHeight;
      var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;

      // device_inner_flex 중심이 화면 중심에 왔을 때 애니메이션 완료
      var trackCenterDoc = trackTopDoc + (trackHeight * 0.5);
      var start = trackTopDoc - viewportH;
      var end = trackCenterDoc - (viewportH * 0.5);

      if (end <= start) {
        end = start + 1;
      }

      var linearProgress = clamp((scrollY - start) / (end - start), 0, 1);
      var progress = linearProgress * linearProgress * (3 - (2 * linearProgress)); // smoothstep
      var riseY = isMobile ? 0 : (1 - progress) * 140;
      var gapStart = isMobile ? 14 : 132;
      var gapEnd = isMobile ? 0 : 0;
      var scaleStart = isMobile ? 0.82 : 0.80;
      var scaleEnd = isMobile ? 1.10 : 1.12;
      var flexWidthStart = isMobile ? 100 : 40;
      var flexWidthEnd = isMobile ? 80 : 40;
      var gap = gapStart + ((gapEnd - gapStart) * progress);
      var scale = scaleStart + ((scaleEnd - scaleStart) * progress);
      var flexWidth = flexWidthStart + ((flexWidthEnd - flexWidthStart) * progress);

      deviceSection.style.setProperty("--device-rise-y", riseY.toFixed(2) + "px");
      deviceSection.style.setProperty("--device-gap", gap.toFixed(2) + "px");
      deviceSection.style.setProperty("--device-scale", scale.toFixed(3));
      deviceSection.style.setProperty("--device-flex-width", flexWidth.toFixed(2) + "%");
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateScene();
        ticking = false;
      });
    }

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);

    if (typeof mobileMQ.addEventListener === "function") {
      mobileMQ.addEventListener("change", requestUpdate);
    } else if (typeof mobileMQ.addListener === "function") {
      mobileMQ.addListener(requestUpdate);
    }

    updateScene();
  })();

var appSlide = new Swiper('.app_slide_inner', {
            slidesPerView: 1, 
            spaceBetween: 0,      
             pagination: {
              el: ".app-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".app-next",
              prevEl: ".app-prev",
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
        
              },
              
            }
    
    
      });

 $(document).on('click', '.prd_plus', function() {
    var $gradient = $(this);
    var $target = $gradient.prev('.bna-slide-inner'); // 바로 이전 형제 요소 선택

    if ($target.length) {
      $target.toggleClass('open'); // open 클래스 토글
    }
  });


// Modal
var modals = document.getElementsByClassName("modal");
var btns = document.getElementsByClassName("modalBtn");
var spanes = document.getElementsByClassName("close");
var funcs = [];
 

function Modal(num) {
  return function() {
   
    btns[num].onclick =  function() {
        modals[num].style.display = "block";
        console.log(num);
    };

    spanes[num].onclick = function() {
        modals[num].style.display = "none";
    };
  };
}
 
for(var i = 0; i < btns.length; i++) {
  funcs[i] = Modal(i);
}
 
for(var j = 0; j < btns.length; j++) {
  funcs[j]();
}
 
window.onclick = function(event) {
  if (event.target.className == "modal") {
      event.target.style.display = "none";
  }
};

 });

function downloadPDF(pdfUrl) {
    fetch(pdfUrl)
        .then(response => response.blob()) 
        .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = pdfUrl.split('/').pop().split('?')[0];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href); 
        })
        .catch(error => console.error("PDF 다운로드 오류:", error));
}



// PDF 다운로드 피씨
      document.querySelectorAll(".downloadLink").forEach(link => {
    link.addEventListener("click", function(event) {
        event.preventDefault(); // 기본 동작 방지

        const fileUrl = this.getAttribute("data-pdf"); 
        const fileName = fileUrl.split("/").pop().split("?")[0];

        fetch(fileUrl)
            .then(response => response.blob()) 
            .then(blob => {
                const downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            })
            .catch(error => console.error("파일 다운로드 오류:", error));
    });
});
